<script>
export default {
  name: 'library-card',
  data: () => ({}),
  computed: {},
  methods: {},
  created() {},
}
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="d-flex flex-column align-center">
        <h1 class="text-h2 primary--text font-weight-bold">Library Cards</h1>

        <v-card max-width="140ch" class="mt-12">
          <img
            src="https://media.eipl.org/site/images/services/librarycard.jpg"
            class="d-block my-8 mx-auto"
          />

          <v-card-title>
            <h2 class="text-h6 primary--text font-weight-bold">
              Applying For a Library Card
            </h2>
          </v-card-title>
          <v-card-text class="black--text text-body-1 text-left py-8">
            <p class="text-left">
              At the Circulation Center you may apply for a new card, replace a
              lost one, or update your current card.
            </p>

            <p>
              Library cards are free of charge to all residents and taxpayers of
              East Islip, Islip Terrace and Great River.
            </p>

            <p>
              You will need to fill out an application and provide two (2) forms
              of valid identification, such as: a driver's license car
              registration checkbook current utility bill with your name and
              mailing address.
            </p>
            <p>
              Children from birth to grade 6 are eligible for their own library
              cards with the signature of a parent or guardian.
              <br />
              Teens from grade 7 to 17 years of age can apply for their own
              card, but still require parental permission for video and DVD
              privileges and unrestricted Internet access.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped></style>
